import React, { Component, ReactPortal, RefObject } from 'react';
import { createPortal } from 'react-dom';

interface IPortalProps {
  containerRef?: RefObject<HTMLElement>;
  children: React.ReactNode;
}

export class Portal extends Component<IPortalProps> {
  private container: HTMLElement | null = null;

  private createContainer(): HTMLElement {
    if (!this.container) {
      this.container = document.createElement('div');

      document.body.appendChild(this.container);
    }

    return this.container;
  }

  private cleanupContainer(): void {
    if (!this.container) {
      return;
    }

    document.body.removeChild(this.container);

    this.container = null;
  }

  componentWillUnmount(): void {
    this.cleanupContainer();
  }

  render(): ReactPortal {
    const { children, containerRef } = this.props;

    let container: HTMLElement;

    if (containerRef?.current) {
      container = containerRef.current;

      this.cleanupContainer();
    } else {
      container = this.createContainer();
    }

    return createPortal(children, container);
  }
}
